export const HEADER_HEIGHT = 60;
export const STICKY_BAR_HEIGHT = 80;
